module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.nameConfirmed) ? _c('div', [_c('h1', [_vm._v("Boodschapp")]), _vm._v(" "), _c('p', [_vm._v("Wat is je naam?")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Naam",
      "id": "testing"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.nameConfirmed = true
      }
    }
  }, [_vm._v("Bevestigen")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.nameConfirmed) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "authentication__title"
  }, [_vm._v("Boodschapp")]), _vm._v(" "), _c('p', [_vm._v("Hoi " + _vm._s(_vm.name) + ", voordat je kan beginnen moet je een account aanmaken. Hiervoor heb je een e-mailadres en een wachtwoord nodig.")])])], 1)], 1), _vm._v(" "), _c('credentials', {
    attrs: {
      "emailAddress": _vm.emailAddress,
      "password": _vm.password
    },
    on: {
      "emailaddressEntered": _vm.emailaddressEntered,
      "passwordEntered": _vm.passwordEntered,
      "confirmed": _vm.confirmedRegister
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bbbede6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/authenticate/Register.vue
// module id = 491
// module chunks = 1